module.exports = __webpack_public_path__ + "img/error-icon.6d2c4a6d.svg";